import { Component, input, output, computed, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnSettings } from '../../../../../models/column-settings';
import { environment } from 'src/environments/environment';
import { LTGenericGridPngComponent } from '../lt-generic-grid-png/lt-generic-grid-png';
import { GridSort } from 'src/app/features/grid/classes/grid-config.types';
@Component({
  selector: 'app-lt-generic-grid-wrapper',
  imports: [
    CommonModule,
    LTGenericGridPngComponent,
  ],
  standalone: true,
  templateUrl: './lt-generic-grid-wrapper.html',
  styleUrl: './lt-generic-grid-wrapper.scss',
})
export class LTGenericGridWrapperComponent {

  // grid references
  pngGrid = viewChild<LTGenericGridPngComponent>('genericGridPng', {});

  //#region Mirror ViewGenericGrid inputs
  readonly data = input<any[]>([]);
  readonly loading = input<boolean>(false);
  readonly customExport = input<boolean>(false);
  readonly exportFileName = input<string>('Data');
  readonly columns = input<ColumnSettings[]>([]);
  readonly isReorderable = input<boolean>(true);
  readonly isFilterable = input<boolean>(true);
  readonly isResizeable = input<boolean>(false);
  readonly isSelectable = input<boolean>(true);
  readonly showSelectionColumn = input<boolean>(false);
  readonly showColumnMenu = input<boolean>(true);
  readonly selectionfield = input<string>('');
  readonly showExportToolbar = input<boolean>(true);
  readonly showChangeSelection = input<boolean>(false);
  readonly sortDescriptions = input<GridSort[]>([]);
  readonly enableAutoFit = input<boolean>(false);
  // action column props
  readonly hasActionGoToColumn = input<boolean>(false);
  readonly actionGoToUsePrefix = input<boolean>(false);
  readonly actionGoToField = input<string>('');
  readonly actionGoToPrefix = input<string>('');
  readonly actionGoToFieldAddl = input<string[]>([]);
  readonly actionGoToUseAddlField = input<boolean>(false);
  readonly actionGoToUseSuffix = input<boolean>(false);
  readonly actionGoToSuffix = input<string>('');
  // selection props
  readonly showSelectDeselectButtons = input<boolean>(false);
  readonly selectionColumnWidth = input<number>(100);
  readonly selectionColumnHeader = input<string>('Select');
  readonly overrideSelectedItem = input<any>(null);
  //#endregion

  //#region Outputs
  readonly getUpdated = output<string>();
  readonly itemSelected = output<any>();
  //#endregion

  constructor() {
    
  }

  // Event handlers that maintain compatibility with ViewGenericGridComponent
  onSelectionChange(selectedItem: any): void {
    this.itemSelected.emit(selectedItem);
  }


  public resetSkipIndex(): void {
    this.pngGrid().resetSkipIndex();
  }

  public fitColumns(): void {
    // png grid does not implement fitColumns method
  }

}
